import axios from 'axios'
import Vue from 'vue'
import store from '../../store'
import baseConfig from './baseConfig'

async function handleError(error) {
  const status = error.response ? error.response.status : null

  if ((status === 401) || (status === 403)) {
    const idToken = await Vue.prototype.$auth.getIdToken(true)
    const { config } = error
    config.headers.Authorization = `Bearer ${idToken}`

    return axios.request(config)
  }

  return Promise.reject(error)
}

async function createAxios(withAuth = true, timeout = null, idTokenSpecified = null) {
  const config = baseConfig
  if (withAuth) {
    const idToken = idTokenSpecified || await Vue.prototype.$auth.getIdToken()
    config.headers.Authorization = `Bearer ${idToken}`
  }

  config.timeout = timeout || store.state.remoteConfig?.networkTimeoutMillis || baseConfig.timeout
  const instance = axios.create(config)
  instance.interceptors.response.use(response => response, handleError)

  return instance
}

export default createAxios
